
import {_q} from './../../util/util'
import { mapState } from 'vuex'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'

import { getCategories, getCommodityList, getCommoditybyName, getStore, getAllCommoditySeries } from './../../service/index'
import { go } from './../../util/router'
import { zdsCategory } from './../../config/env'
import { setItem } from '@/util/jwtAuth'

let YHPS = [
{number: '140101', name: '辅料包装物', cur: false},
{number: '140102', name: '辅料宣传品', cur: false},
{number: '140103', name: '辅料门店用品', cur: false},
{number: '140104', name: '辅料门店日常单据', cur: false},
{number: '140105', name: '辅料门店辅助工具', cur: false},
{number: '140106', name: '辅料店员工服', cur: false},
{number: '140107', name: '辅料荣誉牌', cur: false},
{number: '140108', name: '辅料其它', cur: false},
{number: '140109', name: '辅料工厂物料', cur: false},
{number: '150101', name: '虚拟商品', cur: false}
]
export default {
data () {
return {
KeyWord: '',
isT: false,
firstCategory: [{oid: zdsCategory.ZSQ, name: '镶嵌', cur: true}, {oid: zdsCategory.ZSJ, name: '素金', cur: false}, {oid: zdsCategory.ZLW, name: '礼品', cur: false}, {oid: zdsCategory.ZYHP, name: '易耗品', cur: false}],
secondCategory: [{number: '', name: '全部', cur: true}, {number: '0', name: '无款', cur: false}],
secondCategoryList: [],
commoditySeries: [{number: '', name: '全部', cur: true}],
commoditySeriesList: [],
curFirst: {},
curSecond: null,
curThird: {number: ''},
List: [],
pageIndex: 0,
pageSize: 10,
pageCount: 0,
isLock: false,
isSearch: false,
isSupport: false,
UserInfo: '',

bind_P: ''
}
},
components: {
Group, Cell, XSwitch
},
created () {
let vm = this
vm.curFirst = vm.firstCategory[0]
getStore(null, (result) => {
if (result.code === '1') {
let user = JSON.parse(result.data)
vm.UserInfo = user.StoreNumber
setItem('ZDS_Store', {name: String(user.FSHOP_STATUS).substring(0, 2)})
}
})
getAllCommoditySeries((result) => {
if (result.code === '1') {
let ls = JSON.parse(result.data)
vm.commoditySeriesList = ls
for (let item of ls) {
if (item.CommondityType === 0) {
vm.commoditySeries.push({
cur: false,
number: item.CategoryNumber,
name: item.CategoryName
})
}
}
}
getCategories(null, (result) => {
if (result.code === '1') {
let ls = JSON.parse(result.data)
vm.secondCategoryList = ls
for (let item of ls) {
vm.secondCategory.push({
cur: false,
number: item.CategoryNumber,
name: item.CategoryName
})
}
vm.curSecond = vm.secondCategory[0]
vm.curThird = vm.commoditySeries[0]
vm.getCListById()
}
})
})
},
mounted () {

let _P = localStorage.getItem('_P')
if(_P){
this.bind_P = '?p='+_P
}

this.pagescroll()
_q('.right-list .items').style.height = document.documentElement.clientHeight - 90 + 'px'
_q('.middle-list .items').style.height = document.documentElement.clientHeight - 90 + 'px'
},
watch: {
'$route': function (to, from) {
if (to.name === 'home') {
this.pagescroll()
}

let filter = document.getElementById('filter')
let aside = document.getElementById('aside')
if(filter){
this.isT = false
filter.remove()
}
if(aside){
this.isT = false
aside.style.WebkitTransition  = 'none'
aside.className = 'side_animation'
setTimeout(()=>{aside.style  = ''},200)
}
}
},
methods: {
onClick () {
let vm = this
vm.pageIndex = 0
vm.pageCount = 0
vm.isSearch = false
vm.List = []
this.getCListById()
},
doside () {
let vm = this
if (this.isT) {
this.isT = false
_q('aside').className = 'side_animation'
} else {
this.isT = true
var filter = document.createElement('div')
filter.id = 'filter'
document.body.appendChild(filter)
filter.onclick = function () {
vm.doside()
this.remove()
}
_q('aside').className = 'side_animation side_open'
}
},
sltFirst (obj) {
if (obj.cur) {
return
}
let vm = this
vm.curFirst.cur = false
obj.cur = true
vm.curFirst = obj
vm.secondCategory = [{number: '', name: '全部', cur: true}]
vm.commoditySeries = [{number: '', name: '全部', cur: true}]
if (obj.oid === zdsCategory.ZSQ || obj.oid === zdsCategory.ZSJ) {
vm.secondCategory.push({number: '0', name: '无款', cur: false})
}
if (obj.oid === zdsCategory.ZYHP) {
for (let item of YHPS) {
vm.secondCategory.push({
cur: false,
number: item.number,
name: item.name
})
}
} else {
for (let item of vm.secondCategoryList) {
vm.secondCategory.push({
cur: false,
number: item.CategoryNumber,
name: item.CategoryName
})
}
}
if (obj.oid === zdsCategory.ZSQ) {
for (let item of vm.commoditySeriesList) {
if (item.CommondityType === 0) {
vm.commoditySeries.push({
cur: false,
number: item.CategoryNumber,
name: item.CategoryName
})
}
}
} else if (obj.oid === zdsCategory.ZSJ) {
for (let item of vm.commoditySeriesList) {
if (item.CommondityType === 1) {
vm.commoditySeries.push({
cur: false,
number: item.CategoryNumber,
name: item.CategoryName
})
}
}
}
this.curThird = vm.commoditySeries[0]
},
sltThird (obj) {
if (obj.cur) {
return
}
obj.cur = true
if (this.curThird) {
this.curThird.cur = false
}
this.curThird = obj
},
sltSecond (obj) {
obj.cur = true
let vm = this
this.isT = false
_q('aside').className = 'side_animation'
_q('#filter').remove()
if (vm.curSecond) {
vm.curSecond.cur = false
}
vm.curSecond = obj
vm.pageIndex = 0
vm.pageCount = 0
vm.isSearch = false
vm.List = []
vm.getCListById()
},
searchData () {
let vm = this
if (this.KeyWord === '' && vm.List.length === 0) {
vm.showAlert('搜索条件不能为空！')
return
}
vm.pageIndex = 0
vm.pageCount = 0
vm.isSearch = true
vm.List = []
vm.getCListByName()
},
getCListById (zdl, zpm) {
let vm = this
let pData = {
MARA_MTART: vm.curFirst.oid,
ZPM: vm.curSecond.number,
kind: vm.isSupport ? 1 : 0,
pageNum: vm.pageIndex,
pageSize: 10,
FERTH: vm.curThird.name
}
vm.isLock = true
pData.FERTH = String(pData.FERTH).replace(/全部/, '')
getCommodityList(pData, (result) => {
vm.isLock = false
if (result.code === '1') {
let tag = JSON.parse(result.tag)
vm.pageCount = tag.Dict.records
let ls = JSON.parse(result.data)
for (let item of ls) {
vm.List.push(item)
}
}
})
},
getCListByName () {
let vm = this
let pData = {
commodityName: vm.KeyWord,
kind: vm.isSupport ? 1 : 0,
pageNum: vm.pageIndex,
pageSize: 10,
FERTH: vm.curThird.name
}
vm.isLock = true
pData.FERTH = String(pData.FERTH).replace(/全部/, '')
getCommoditybyName(pData, (result) => {
vm.isLock = false
if (result.code === '1') {
let tag = JSON.parse(result.tag)
vm.pageCount = tag.Dict.records
let ls = JSON.parse(result.data)
for (let item of ls) {
vm.List.push(item)
}
}
})
},
pagescroll () {
let self = this
window.onscroll = function () {
let body = document.body
let scrollTop = body.scrollTop === 0 ? document.documentElement.scrollTop : body.scrollTop
let dHeight = body.scrollHeight
let height = document.documentElement.clientHeight
if (self.isT) {
return
}

if ((scrollTop + height) >= dHeight-100) {
if ((self.pageCount - self.pageIndex * self.pageSize) > self.pageSize) {
if (!self.isLock) {
self.isLock = true
self.pageIndex += 1
if (self.isSearch) {
self.getCListByName()
} else {
self.getCListById()
}
}
}
}
}
},
doDetail (oid) {
go('Detail/' + oid, this.$router)
}
},
computed: {
...mapState({
route: state => state.route,
path: state => state.route.path
})
}
}



// WEBPACK FOOTER //
// ./src/page/home/index.vue